/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
// eslint-disable-next-line import/order
import { createSelector } from "@reduxjs/toolkit";
import { subsidiaryApi } from "./api-slice";
import { ISubsidiaryListResponse, ISubsidiaryResponse } from "@bvi/api-interfaces/response/manage-base-data";

export const selectSubsidiary = createSelector(
  (response?: ISubsidiaryListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectSubsidiaryListResult = () =>
  subsidiaryApi.endpoints.getSubsidiaryList.select();

export const selectResponse = (data?: ISubsidiaryResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};
